import { type FC, type ReactNode } from "react";

import { isProdLike } from "../../shared/constants";
import { useAppAnalytics, useSentryTracing } from "../hooks";

import { CookiePopupWrapper } from "./CookiePopupWrapper";

export const AnalyticsContainer: FC<{ children?: ReactNode }> = ({ children }) => {
    const { runInitializeAnalytics } = useAppAnalytics(!isProdLike());

    useSentryTracing();

    if (!isProdLike()) {
        return <>{children}</>;
    }

    return (
        <>
            {children}
            <CookiePopupWrapper performanceAnalyticsCallback={runInitializeAnalytics} />
        </>
    );
};
